/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'

import Menu from '../../../../components/InternalMenu/Menu'
import Table from '../../../../components/InternalMenu/FaqList'

import { useNavigate } from 'react-router-dom'

import foodIcon from '../../../../assets/svg/supportIcon.svg'
import { get } from '../../../../services/http'

import { notify } from '../../../../components/Toast'
import { ToastContainer } from 'react-toastify'

export default function index() {
  const [faqs, setFaqs] = useState('')
  const [faqsCount, setFaqsCount] = useState()
  const [totalPage, setTotalPage] = useState()
  const [faqStatus, setFaqStatus] = useState(false)

  const token = localStorage.getItem('token')

  const navigate = useNavigate()
  document.title = 'سوالات متداول'

  const navigateHandler = () => {
    navigate('/im/faq/create')
  }

  useEffect(() => {
    get(`/api/admin/im/faq?token=${token}`).then(response => {
      setFaqs(response.data.data.docs)
      if (response.data.data.docs.length >= 1) {
        setFaqStatus(true)
      }
      setTotalPage(response.data.data.pages)
      setFaqsCount(response.data.data.totalDocs)
    })
  }, [token])

  const handlePageClick = (event) => {
    get(`/api/admin/im/sliders?page=${event.selected + 1}&token=${token}`)
    .then(respose => {
      setFaqs(respose.data.data.docs)
      setTotalPage(respose.data.data.pages)
      setFaqsCount(respose.data.data.totalDocs)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'faq'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={foodIcon} width={'20px'} alt='resturantIcon' />
              </div>
              <div className='text'>
                لیست سوالات
              </div>
            </div>

            <div className="left">
              <button onClick={navigateHandler} style={faqStatus ? { display: 'none' } : { }}>ایجاد سوال</button>
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد کل سوالات
              </div>
              <div className="left">
                {faqsCount}
              </div>
            </div>

            <Table data={faqs} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
